<template>
  <a :href="step.href" class="flow-step" :class="`flow-step--${step.status}`">
    <span class="flow-step__counter">
      <template v-if="step.status !== 'completed'">
        {{ number }}
      </template>
      <i v-else class="fa fa-check" aria-hidden="true"></i>
    </span>
    <p class="flow-step__name">{{ step.name }}</p>
  </a>
</template>

<script>
export default {
  name: 'flow-step',
  props: {
    step: {
      type: Object,
      required: true,
    },
    number: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-step {
  text-align: center;
  line-height: 16px;
  min-width: 150px;
  padding: 18px 0;
  &--incomplete {
    pointer-events: none;
  }
  &--completed &__counter {
    background: $half-baked-color;
  }
  &--active &__counter {
    background: #fff;
    border: 2px solid $half-baked-color;
    color: $half-baked-color;
  }
  &__counter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-bottom: 16px;
    font-weight: 600;
    color: #fff;
    background: $dove-grey-color;
  }
  &__name {
    font-size: 16px;
    font-weight: 600;
    color: $dove-grey-color;
    margin: 0;
  }
}
</style>
